import styled from 'styled-components'

import { helpers } from 'styles'

type Props = {
	isActive?: boolean
}

export const Marker = styled.div<Props>`
	display: grid;
	place-items: center;
	width: 32px;
	height: 32px;
	border-radius: 50%;
	background-color: ${({ isActive, theme }) => (isActive ? theme.color.action : helpers.color.disabled)};
	color: ${helpers.color.textContrast};
	font-size: 20px;
	font-weight: 500;
	line-height: 1;
`
